import styles from './count.module.scss';

export interface Props {
	count?: number;
}

export const Count = ({ count }: Props) => {
	return (
		<span className={styles.count}>
			({(count ? count : 0).toLocaleString()})
		</span>
	);
};
